var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c("SoliText", {
        attrs: {
          number: "",
          label: "Student Capacity",
          value: _vm.recommended,
          "hide-details": "auto",
          icon: "people",
          min: 1,
          max: 100,
          rules: [(val) => !!val || "This field is required"],
          validateOnBlur: false,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }